import React from 'react';

const Smile: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" {...props}>
    <path
      fill="currentColor"
      d="M18 0a18 18 0 1018 18A18.02 18.02 0 0018 0zm-6.75 10.5a3 3 0 110 5.999 3 3 0 010-5.999zm-.662 13.064a.656.656 0 01.569-.33h13.684a.658.658 0 01.57.986 8.559 8.559 0 01-14.823 0 .654.654 0 010-.656zM24.75 16.5a3 3 0 110-5.999 3 3 0 010 5.999z"
    ></path>
  </svg>
);

export default Smile;
